var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43762 6.64248C2.1635 6.41757 1.80629 6.29554 1.43766 6.30087C1.06903 6.3062 0.716246 6.43849 0.450066 6.67121C0.183887 6.90393 0.0240054 7.21987 0.00249123 7.55564C-0.0190229 7.89142 0.0994217 8.22219 0.334067 8.48162L3.57705 11.5868C3.71283 11.7168 3.87598 11.8204 4.05672 11.8913C4.23745 11.9623 4.43205 11.9993 4.62883 12C4.82456 12.001 5.01853 11.9662 5.19921 11.8975C5.37989 11.8288 5.54359 11.7277 5.68061 11.6002L15.5849 2.27119C15.7191 2.14518 15.8249 1.99628 15.8961 1.83298C15.9673 1.66968 16.0026 1.49518 15.9999 1.31945C15.9971 1.14372 15.9565 0.970196 15.8803 0.80879C15.8041 0.647384 15.6938 0.501255 15.5556 0.378745C15.4175 0.256235 15.2543 0.159744 15.0753 0.094782C14.8963 0.0298196 14.705 -0.00234234 14.5124 0.000132731C14.3198 0.0026078 14.1296 0.0396712 13.9527 0.109207C13.7758 0.178743 13.6156 0.279389 13.4813 0.405399L4.64344 8.74816L2.43762 6.64248Z",
    fill: "#27AE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.b14a8dd81a57a022fe42bd662e8884bd.svg";
export { ForwardRef as ReactComponent };